import React, { useEffect, useState } from 'react';
import Slider from "rc-slider";
import YouTube from 'react-youtube'
import styles from '../../css/styling.module.css';
import { getActivityReplyImages } from '../../../actions/activities_reply_actions';
import ReactPlayer from 'react-player'
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import "rc-slider/assets/index.css";





const Question_With_Slider2 = (props) => {
    const [currentOption, setCurrentOption] = useState(props.selected || props.options[0]);
    const [isSliding, setIsSliding] = useState(false);

    // On option change
    const onOptionChange = (value) => {




        const selectedOptionIndex = Math.round((value / 100) * (props.options.length - 1));
        const selectedOption = props.options[selectedOptionIndex];
        setCurrentOption(selectedOption);

        props.allContent.content[props.categoryIndex].questions[props.questionIndex].selected = selectedOption;
        props.allContent.content[props.categoryIndex].questions[props.questionIndex].q = props.questionNo;
        props.setContent({ ...props.allContent });



    }

    const handleMarks = () => {

        return props.options.reduce((arr, val, index) => ({
            ...arr,
            [parseInt(((index + 1) / props.options.length) * 100)]: ''
        }), {});

    }

    useEffect(() => {
        //console.log('useEffect triggered');
        //console.log('props.questionNo at start of useEffect ->', props.questionNo);

        if (!props.selected) {
            const currentOption = props.options[0];
            setCurrentOption(currentOption);
            // console.log('Set currentOption to ->', currentOption);
            // console.log('props.questionNo after setting currentOption ->', props.questionNo);

            if (props.allContent !== undefined) {
                //console.log('props.questionNo before updating allContent ->', props.questionNo);
                props.allContent.content[props.categoryIndex].questions[props.questionIndex].selected = currentOption;

            }
        }
    }, [props.selected, props.options, props.questionNo, props.allContent, props.categoryIndex, props.questionIndex]);

    useEffect(() => {

        props.allContent.content[props.categoryIndex].questions[props.questionIndex].q = props.questionNo;

        props.setContent({ ...props.allContent });
    }, [props.questionNo]);

    // const handleMarks = () => {
    //     return props.options.reduce((arr, val, index) => ({
    //         ...arr,
    //         [parseInt(((index + 1) / props.options.length) * 100)]: val
    //     }), {});
    // };


    const makeLinksOpenInNewTab = (htmlContent) => {
        // Create a DOM element to parse the HTML content
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlContent;

        // Find all anchor tags within the parsed HTML content
        const anchorTags = tempElement.getElementsByTagName('a');

        // Iterate through the anchor tags and set the target attribute to '_blank'
        for (const anchorTag of anchorTags) {
            anchorTag.setAttribute('target', '_blank');
            // You can also set 'rel' attribute to 'noopener noreferrer' for security best practices
            anchorTag.setAttribute('rel', 'noopener noreferrer');
        }

        // Return the modified HTML content
        return tempElement.innerHTML;
    }


    const opts = {
        width: '640',
        height: '360',
        playerVars: {
            autoplay: 0
        },
    };

    const params = useParams();
    const dispatch = useDispatch();

    const [localVideoUrls, setLocalVideoUrls] = useState({});
    const [loadingVideoLocal, setLoadingVideoLocal] = useState({});
    const [localImageUrls, setLocalImageUrls] = useState({});
    const catId = props.categoryId
    const questionIndex = props.questionIndex


    const loadVideoFile = (filePath) => {
        if (!filePath || localVideoUrls[filePath] || loadingVideoLocal[filePath]) return;

        setLoadingVideoLocal(prev => ({ ...prev, [filePath]: true }));

        dispatch(getActivityReplyImages([filePath]))
            .then((fileRes) => {
                const resolvedContent = fileRes.payload.content;
                const url = resolvedContent[0]?.fileData?.url || filePath;
                setLocalVideoUrls(prev => ({ ...prev, [filePath]: url }));
            })
            .catch(err => console.error('Failed to resolve video file:', err))
            .finally(() => {
                setLoadingVideoLocal(prev => {
                    const updated = { ...prev };
                    delete updated[filePath];
                    return updated;
                });
            });
    };

    const isVideoResolved = (file) => !!localVideoUrls[file];

    const getFileUrl = (file) => {
        if (typeof file === 'string') {
            if (localVideoUrls[file]) return localVideoUrls[file];
            if (localImageUrls[file]) return localImageUrls[file];
            return file;
        }
        return URL.createObjectURL(file);
    };

    const getFileExtension = (file) => {
        if (typeof file === 'string') {
            return file.split('?')[0].split('.').pop().toLowerCase();
        }
        return file.name.split('.').pop().toLowerCase();
    };

    useEffect(() => {
        if (Array.isArray(props.questionFile) && props.questionFile.length > 0) {
            const pathsToResolve = props.questionFile.filter(f => {
                if (typeof f !== 'string' || f === '') return false;
                const ext = f.split('?')[0].split('.').pop().toLowerCase();
                return ext !== 'mp4' && !localImageUrls[f];
            });

            if (pathsToResolve.length > 0) {
                dispatch(getActivityReplyImages(pathsToResolve))
                    .then((fileRes) => {
                        const resolvedContent = fileRes.payload.content;
                        const urlMap = {};
                        pathsToResolve.forEach((path, idx) => {
                            urlMap[path] = resolvedContent[idx]?.fileData?.url || path;
                        });
                        setLocalImageUrls(prev => ({ ...prev, ...urlMap }));
                    })
                    .catch(err => console.error('Failed to resolve image files:', err));
            }
        }
    }, [props.questionFile]);

    return (
        <div className="my-3">
            <div className={styles.card_border} style={props.required && !props.isAnswered ? { borderColor: '#d92550' } : {}}>
                <div className={styles.card_border_body + " pt-4 pb-1"}>
                    <p style={{ color: '#666', fontSize: "1rem", fontWeight: '500', whiteSpace: 'pre-wrap' }} className="mb-0">

                        {/* Required check */}
                        {props.required &&
                            <span className="text-danger mr-1">*</span>
                        }

                        {/* Question text */}
                        {props.questionText &&
                            <span style={{ color: '#000', fontSize: '27px', fontWeight: '500' }} className='mb-0' dangerouslySetInnerHTML={{ __html: makeLinksOpenInNewTab(props.questionText) }} />
                        }

                        {/* Question video */}
                        {props.questionVideo && (
                            <div>

                                <YouTube videoId={props.questionVideo} opts={opts} className='py-4 text-center'></YouTube>

                            </div>
                        )}

                    </p>

                    {/* Question Video */}
                    {
                        props.questionFile &&
                        <>
                            {
                                props.questionFile && props.questionFile.length > 0 && (
                                    <div className="mx-3 mt-2 mb-4">
                                        <div className="pt-3 d-flex flex-wrap" style={{ gap: '16px' }}>
                                            {props.questionFile.map((file, index) => {
                                                const ext = getFileExtension(file);
                                                const isVideoFile = ext === 'mp4';
                                                const fileUrl = getFileUrl(file);

                                                return (
                                                    <div key={index} className="position-relative">
                                                        {isVideoFile ? (
                                                            isVideoResolved(file) ? (
                                                                <div style={{ maxWidth: '300px', overflow: 'hidden' }}>
                                                                    <ReactPlayer url={fileUrl} controls width="100%" />
                                                                </div>
                                                            ) : (
                                                                <div style={{
                                                                    width: '200px', height: '140px',
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                    border: '2px dashed #ccc', borderRadius: '10px', backgroundColor: '#f8f9fa'
                                                                }}>
                                                                    {loadingVideoLocal[file] ? (
                                                                        <button type="button" className="btn btn-secondary d-flex align-items-center"
                                                                            style={{ color: 'white', fontSize: '12px', gap: '6px' }} disabled>
                                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                            Downloading...
                                                                        </button>
                                                                    ) : (
                                                                        <button type="button" className="btn btn-secondary"
                                                                            style={{ color: 'white', fontSize: '12px' }}
                                                                            onClick={() => loadVideoFile(file)}>
                                                                            Load Video
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )
                                                        ) : (
                                                            <img src={fileUrl} className={`img-fluid border ${styles.banner_image} my-2`}
                                                                style={{ borderRadius: '10px', maxWidth: '300px' }} alt="img" />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    }


                    {/* Options */}
                    <div className="table-responsive">
                        <div>
                            <div className="mx-4" style={{ height: '160px', marginTop: 20, textAlign: "center" }}>
                                <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>

                                    <p style={{ fontSize: '18px', fontWeight: '500' }}>{currentOption == undefined ? props.options[0] : currentOption}</p>
                                </div>
                                <Slider

                                    //dots
                                    // included={true}
                                    min={parseInt((1 / props.options.length) * 100) - 10}
                                    //min={0}

                                    max={100}
                                    marks={handleMarks()}
                                    value={(parseInt(((props.options.indexOf(currentOption) + 1) / props.options.length) * 100))}
                                    step={parseInt(100 / (props.options.length - 1))}
                                    //step={null}
                                    onChange={e => onOptionChange(e)}

                                />

                            </div>

                        </div>
                    </div>

                    {/* Required Answer error */}
                    {props.required && !props.isAnswered && (
                        <div id={`error-msg-${props.id}`}>
                            <div className="my-2">
                                <div className="alert alert-danger mb-0">
                                    Please answer this question.
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )

}

export default Question_With_Slider2;